export default function Header(){
    return (<nav className="navbar fixed-top bg-body-tertiary">
        <div className="container justify-content-center">
            <a className="navbar-brand" href="/">FBA Inbound 2D Barcode Generator</a>
        </div>
    </nav>)
}